import React from "react";
import { RttBaseline } from "./requests/request";
import {
    BASELINE_COLOR,
    BASELINE_OPACITY,
    TYPICAL_DASH,
    UNUSUAL_DASH,
} from "./historyChart";

/** Repeats the line's own dash pattern, so the swatch identifies the line. */
const Swatch: React.FC<{ dash: string; round?: boolean }> = ({
    dash,
    round,
}) => (
    <svg width="20" height="4" aria-hidden="true" className="shrink-0">
        <line
            x1="1"
            y1="2"
            x2="19"
            y2="2"
            stroke={BASELINE_COLOR}
            strokeWidth="2"
            strokeDasharray={dash}
            strokeLinecap={round ? "round" : "butt"}
            strokeOpacity={BASELINE_OPACITY}
        />
    </svg>
);

const format = (value: number | null): string =>
    value === null ? "—" : `${value.toFixed(2)} ms`;

const percentile = (fraction: number): string =>
    `p${Math.round(fraction * 100)}`;

/**
 * Names the two reference lines. They carry no in-chart labels because on a
 * steady link the percentiles land a fraction of a millisecond apart and
 * the labels would overlap — and a line the reader cannot name is worse
 * than no line at all.
 */
const RttBaselineLegend: React.FC<{ baseline: RttBaseline }> = ({
    baseline,
}) => (
    <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-semantic-text-secondary">
        <span className="flex items-center gap-1.5">
            <Swatch dash={TYPICAL_DASH} />
            typical ({percentile(baseline.typicalPercentile)}, {baseline.days}d)
            · {format(baseline.typicalMs)}
        </span>
        <span className="flex items-center gap-1.5">
            <Swatch dash={UNUSUAL_DASH} round={true} />
            unusual ({percentile(baseline.unusualPercentile)}, {baseline.days}d)
            · {format(baseline.unusualMs)}
        </span>
    </div>
);

export default RttBaselineLegend;
